import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import api from "@/lib/api";
import LoyaltyCard from "@/components/LoyaltyCard";
import OrderDetailModal from "@/components/OrderDetailModal";

const statusColors = {
  paid: "bg-green-100 text-green-800",
  confirmed: "bg-green-100 text-green-800",
  pending: "bg-yellow-100 text-yellow-800",
  pending_cod: "bg-yellow-100 text-yellow-800",
  awaiting_transfer: "bg-yellow-100 text-yellow-800",
  awaiting_paypal: "bg-yellow-100 text-yellow-800",
  awaiting_payment: "bg-yellow-100 text-yellow-800",
  initiated: "bg-blue-100 text-blue-800",
  cancelled: "bg-red-100 text-red-800",
};

const Account = () => {
  const { user, loading } = useAuth();
  const { lang, t } = useLang();
  const [orders, setOrders] = useState([]);
  const [openOrderId, setOpenOrderId] = useState(null);

  useEffect(() => {
    if (user) {
      api.get("/orders").then((r) => setOrders(r.data || [])).catch(() => {});
    }
  }, [user]);

  if (loading) return <div className="max-w-[1200px] mx-auto px-6 py-12">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div data-testid="account-page" className="max-w-[1200px] mx-auto px-6 lg:px-10 py-12">
      <p className="overline mb-2">{t("account.welcome")}</p>
      <h1 className="font-serif text-4xl lg:text-5xl mb-2">{user.name}</h1>
      <p className="text-[#736B66] mb-10">{user.email}</p>

      <div className="mb-12">
        <LoyaltyCard />
      </div>

      <h2 className="font-serif text-2xl mb-6">{t("account.myOrders")}</h2>
      {orders.length === 0 ? (
        <p className="text-[#736B66]">{t("account.noOrders")} · <Link to="/shop" className="underline">Shop</Link></p>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <button
              key={o.id}
              type="button"
              onClick={() => setOpenOrderId(o.id)}
              className="w-full text-left bg-white border border-[#EBE5DF] p-6 hover:border-[#D4AF37] transition-colors cursor-pointer"
              data-testid={`order-${o.id}`}
            >
              <div className="flex flex-wrap justify-between gap-4 items-start">
                <div>
                  <p className="text-xs tracking-widest uppercase text-[#736B66]">{t("account.orderNumber")}</p>
                  <p className="font-mono text-sm text-[#D4AF37] hover:underline">{o.id}</p>
                  <p className="text-xs text-[#736B66] mt-1">{new Date(o.created_at).toLocaleString(lang === "el" ? "el-GR" : "en-US")}</p>
                </div>
                <div className="text-right">
                  <p className="font-serif text-2xl mb-1">{o.total.toFixed(2)}€</p>
                  <span className={`inline-block px-3 py-1 text-xs uppercase tracking-widest font-semibold ${statusColors[o.order_status] || "bg-gray-100"}`}>
                    {o.order_status}
                  </span>
                  <span className={`inline-block px-3 py-1 text-xs uppercase tracking-widest font-semibold ml-2 ${statusColors[o.payment_status] || "bg-gray-100"}`}>
                    {o.payment_status}
                  </span>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-[#EBE5DF] text-sm text-[#736B66]">
                {o.items.length} item(s) · {o.payment_method} · Δείτε λεπτομέρειες →
              </div>
            </button>
          ))}
        </div>
      )}

      <OrderDetailModal orderId={openOrderId} onClose={() => setOpenOrderId(null)} />
    </div>
  );
};

export default Account;
